/**
 * A CSV a Czech Excel opens as columns: semicolons, decimal commas, and UTF-8
 * with its byte-order mark — without which "Guláš" arrives as mojibake.
 */

type Cell = string | number;

const quote = (cell: Cell): string => {
  const text = typeof cell === "number" ? String(cell).replace(".", ",") : cell;
  return /[;"\r\n]/.test(text) ? `"${text.replaceAll('"', '""')}"` : text;
};

export function toCsv(rows: readonly (readonly Cell[])[]): string {
  return "\uFEFF" + rows.map((row) => row.map(quote).join(";")).join("\r\n");
}

/** Minor units as a plain amount — "458,00", no currency, a sign when negative. */
export function csvAmount(minor: bigint): string {
  const negative = minor < 0n;
  const abs = negative ? -minor : minor;
  return `${negative ? "-" : ""}${abs / 100n},${(abs % 100n).toString().padStart(2, "0")}`;
}

/** Hand the browser a file to save. */
export function downloadCsv(name: string, text: string): void {
  downloadBlob(name, new Blob([text], { type: "text/csv;charset=utf-8" }));
}

/** Save a file the browser already holds, bytes untouched. */
export function downloadBlob(name: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const link = Object.assign(document.createElement("a"), { href: url, download: name });
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
